export const ADD_ALL_ITEMS_TO_SELECTION = 'ADD_ALL_ITEMS_TO_SELECTION'
export const ADD_TASK_TO_SELECTION = 'ADD_TASK_TO_SELECTION'
export const ADD_SECTION_CHILDREN_TO_SELECTION = 'ADD_SECTION_CHILDREN_TO_SELECTION'
export const ADD_SECTION_TO_SELECTION = 'ADD_SECTION_TO_SELECTION'
export const CLEAR_ITEMS_SELECTION = 'CLEAR_ITEMS_SELECTION'
export const CLOSE_CHECKLIST_SHARE_BY_EMAIL_PANE = 'CLOSE_CHECKLIST_SHARE_BY_EMAIL_PANE'
export const CLOSE_SAVE_CHECKLIST_DIALOG = 'CLOSE_SAVE_CHECKLIST_DIALOG'
export const CLOSE_IMPORT_CHECKLIST_DIALOG = 'CLOSE_IMPORT_CHECKLIST_DIALOG'
export const CLOSE_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG = 'CLOSE_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG'
export const CONTACT_RESPONSIBLE = 'CONTACT_RESPONSIBLE'
export const CREATE_TASK = 'CREATE_TASK'
export const CREATE_SECTION = 'CREATE_SECTION'
export const DELETE_FILDERS = 'DELETE_FILDERS'
export const DELETE_SAVED_CHECKLIST = 'DELETE_SAVED_CHECKLIST'
export const SHARE_SAVED_CHECKLIST = 'SHARE_SAVED_CHECKLIST'
export const RENAME_SAVED_CHECKLIST = 'RENAME_SAVED_CHECKLIST'
export const DELETE_CHECKLIST_DOUBLE_VALIDATION = 'DELETE_CHECKLIST_DOUBLE_VALIDATION'
export const DELETE_TABLE_SELECTION = 'DELETE_TABLE_SELECTION'
export const DELETE_TASK = 'DELETE_TASK'
export const DELETE_TASK_COMMENT = 'DELETE_TASK_COMMENT'
export const DELETE_SECTION = 'DELETE_SECTION'
export const DUPLICATE_TASK = 'DUPLICATE_TASK'
export const EDIT_TASK = 'EDIT_TASK'
export const EDIT_SECTION = 'EDIT_SECTION'
export const GET_ATTACHED_FILE_VERSIONS = 'GET_ATTACHED_FILE_VERSIONS'
export const POST_ATTACHED_FILE_VERSION = 'POST_ATTACHED_FILE_VERSION'
export const SHARE_TASKS = 'SHARE_TASKS'
export const SAVE_CHECKLIST = 'SAVE_CHECKLIST'
export const UPDATE_CHECKLIST = 'UPDATE_CHECKLIST'
export const GET_SAVED_CHECKLISTS = 'GET_SAVED_CHECKLISTS'
export const GET_SELF_SAVED_CHECKLISTS = 'GET_SELF_SAVED_CHECKLISTS'
export const GET_SAVED_CHECKLIST_PREVIEW = 'GET_SAVED_CHECKLIST_PREVIEW'
export const GET_LEXISNEXIS_CHECKLISTS = 'GET_LEXISNEXIS_CHECKLISTS'
export const GET_LEXISNEXIS_CHECKLIST_PREVIEW = 'GET_LEXISNEXIS_CHECKLIST_PREVIEW'
export const IMPORT_CHECKLIST_FROM_CLOSD = 'IMPORT_CHECKLIST_FROM_CLOSD'
export const IMPORT_CHECKLIST_FROM_EXCEL = 'IMPORT_CHECKLIST_FROM_EXCEL'
export const IMPORT_CHECKLIST_FROM_WORD = 'IMPORT_CHECKLIST_FROM_WORD'
export const GET_TASK_STATUS_CATEGORIES = 'GET_TASK_STATUS_CATEGORIES'
export const GET_TASK_DETAILS = 'GET_TASK_DETAILS'
export const MOVE_ITEMS = 'MOVE_ITEMS'
export const GET_CHECKLIST = 'GET_CHECKLIST'
export const GET_CHECKLIST_DETAILS = 'GET_CHECKLIST_DETAILS'
export const GET_CHECKLIST_LAST_UPDATES = 'GET_CHECKLIST_LAST_UPDATES'
export const GET_TASK_COMMENTS = 'GET_TASK_COMMENTS'
export const GET_TASK_FOLDER = 'GET_TASK_FOLDER'
export const MOVE_FILDERS = 'MOVE_FILDERS'
export const OPEN_SAVE_CHECKLIST_DIALOG = 'OPEN_SAVE_CHECKLIST_DIALOG'
export const OPEN_CHECKLIST_SHARE_BY_EMAIL_PANE = 'OPEN_CHECKLIST_SHARE_BY_EMAIL_PANE'
export const POST_TASK_COMMENT = 'POST_TASK_COMMENT'
export const REMOVE_TASK_FROM_SELECTION = 'REMOVE_TASK_FROM_SELECTION'
export const REMOVE_SECTION_CHILDREN_FROM_SELECTION = 'REMOVE_SECTION_CHILDREN_FROM_SELECTION'
export const REMOVE_SECTION_FROM_SELECTION = 'REMOVE_SECTION_FROM_SELECTION'
export const RENAME_ATTACHED_FILE = 'RENAME_ATTACHED_FILE'
export const SHARE_ATTACHED_FILES = 'SHARE_ATTACHED_FILES'
export const SHARE_CHECKLIST_BY_EMAIL = 'SHARE_CHECKLIST_BY_EMAIL'
export const POST_STATUS = 'POST_STATUS'
export const EXPAND_SECTION = 'EXPAND_SECTION'
export const EXPAND_ALL_SECTIONS = 'EXPAND_ALL_SECTIONS'
export const COLLAPSE_SECTION = 'COLLAPSE_SECTION'
export const COLLAPSE_ALL_SECTIONS = 'COLLAPSE_ALL_SECTIONS'
export const DELETE_SEARCH_RESULTS = 'DELETE_SEARCH_RESULTS'
export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS'
export const GET_GLOBAL_TASK_FOLDER = 'GET_GLOBAL_TASK_FOLDER'
export const DOWNLOAD_TODO_FILES = 'DOWNLOAD_TODO_FILES'
export const CHANGE_CHECKLIST_VERSIONING_PANE_TAB = 'CHANGE_CHECKLIST_VERSIONING_PANE_TAB'
export const SET_CHECKLIST_VERSIONING_PANE = 'SET_CHECKLIST_VERSIONING_PANE'
export const CLOSE_CHECKLIST_VERSIONING_PANE = 'CLOSE_CHECKLIST_VERSIONING_PANE'
export const CHANGE_CHECKLIST_PANE_TAB = 'CHANGE_CHECKLIST_PANE_TAB'
export const CHANGE_CHECKLIST_PANE_TASKS = 'CHANGE_CHECKLIST_PANE_TASKS'
export const CLOSE_CHECKLIST_PANE = 'CLOSE_CHECKLIST_PANE'
export const OPEN_CHECKLIST_PANE = 'OPEN_CHECKLIST_PANE'
export const GET_PANE_TASK_DETAILS = 'GET_PANE_TASK_DETAILS'
export const GET_TASK_RIGHTS = 'GET_TASK_RIGHTS'
export const UPDATE_TASK_RIGHTS = 'UPDATE_TASK_RIGHTS'
export const UPDATE_TASK_STATUSES = 'UPDATE_TASK_STATUSES'
export const REFRESH_TASK_FOLDER = 'REFRESH_TASK_FOLDER'
